import { useUserStore } from '../../../store/useUserStore';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';


import { calculateAge } from '../../../utility/utilities';
import IcPlus from '../../../assets/image/ic_plus.svg';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import { Kid } from '../../../types';

interface KidBoxProps {
  kid: Kid;
  onClick: (kid: Kid) => void;
  pressed: number | null;
  setPressed: (id: number | null) => void;
}

function KidBox({ kid, onClick, pressed, setPressed }: KidBoxProps) {
  return (
    <button
      type="button"
      className="flex items-center justify-start w-full gap-3 px-[20px]"
      style={{
        backgroundColor: pressed === kid?.id ? '#F2F2F2' : '#FFF',
      }}
      onClick={() => onClick(kid)}
      onMouseDown={() => setPressed(kid?.id)}
      onMouseUp={() => setPressed(null)}
      onMouseLeave={() => setPressed(null)}
      onTouchStart={() => setPressed(kid?.id)}
      onTouchEnd={() => setPressed(null)}
      onTouchCancel={() => setPressed(null)}
    >
      <div
        className="min-w-[52px] min-h-[52px] overflow-hidden bg-[#F0FCFC] border border-[#EAEAEA] flex items-center justify-center rounded-[24px]"
        style={{ background: '#fff' }}
      >
        {kid?.imageUrl && <img src={kid?.imageUrl} alt="thumnail1" className="w-[52px] h-[52px]" />}
      </div>
      <div className="grow flex flex-col items-start my-[12px]">
        <div className="flex items-center cursor-pointer gap-[5px]">
          <span className="font-[700] text-[16px]">{kid?.kidName ?? '-'}</span>
        </div>
        <div className="text-[12px] font-[400] text-[#363636]">
          {kid?.gender === 'male' ? '남아' : '여아'}•{calculateAge(kid?.kidBirth)}세
        </div>
      </div>
    </button>
  );
}

function ChangeKids() {
  const navigate = useNavigate();
  const user = useUserStore();
  const setUser = user.setUser;
  const [pressed, setPressed] = useState<number | null>(null);

  const handleDecideMainKid = (kid: Kid) => {
    setUser((prev) => ({
      ...prev,
      mainKid: kid,
    }));
    navigate(-1);
  };

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title="아이 변경" onClickPrev={() => navigate(-1)} />
      <div className="pageInner bg-[#FFF]">
        <div
          className="flex flex-col items-start justify-start gap-3 mt-[20px]"
          style={{ width: '100vw', marginLeft: '-23px', marginRight: '-23px' }}
        >
          {user?.kids &&
            user?.kids?.length >= 1 &&
            user?.kids?.map((kid, index) => (
              <KidBox
                key={`${kid?.id}-${String(index)}`}
                kid={kid}
                onClick={handleDecideMainKid}
                pressed={pressed}
                setPressed={setPressed}
              />
            ))}
        </div>
        <div className="flex flex-col items-start justify-start w-full gap-3 mt-[20px]">
          <button
            type="button"
            className="flex items-center justify-start w-full gap-3 cursor-pointer"
            onClick={() => navigate(Url.KidsRegister)}
          >
            <div
              className="min-w-[52px] min-h-[52px] bg-[#FFF] border border-[#EAEAEA] flex items-center justify-center rounded-[24px]"
              style={{
                borderRadius: '20px',
                border: '2px dashed var(--devider-devider-1, #C6C6C6)',
              }}
            >
              <img src={IcPlus} alt="thumnail1" className="w-[9px] h-[9px]" />
            </div>
            <div className="grow flex flex-col items-start my-[12px]">
              <div className="font-[700] text-[16px]">아이 추가하기</div>
            </div>
          </button>
        </div>
      </div>
    </FullHeightContainer>
  );
}

export default ChangeKids;
